export const defaultTrendingList = [
  'bitcoin',
  'ethereum',
  'solana',
  'dogecoin',
  'polygon-ecosystem-token',
  'binancecoin'
];
